<script>
	import { onMount } from "svelte";
	// import { scannerList } from "../store/scanner.store";

	let sDate = "";
	let eDate = "";
	let popupOpen = false;

	onMount(() => {});

	function getAllData() {
		if (!checkDate()) return;
		console.log("sDate: ", sDate);
		console.log("eDate: ", eDate);
	}

	function checkDate() {
		if (sDate === "" || eDate === "") return true;

		let startDate = new Date(sDate);
		let endDate = new Date(eDate);

		// 두 날짜를 비교
		if (startDate.getTime() > endDate.getTime()) {
			alert("시작 날짜가 종료 날짜보다 이후입니다.");
			return false;
		}

		return true;
	}

	function getData() {
		popupOpen = true;
	}
</script>

<div class="retrieve-wrap">
	<div class="retrieve-in">
		<p class="retrieve-title">기간조회</p>
		<div class="cal-date">
			<input
				type="date"
				bind:value={sDate}
				data-placeholder="날짜선택"
				required
			/>
			<span>~</span>
			<input
				type="date"
				bind:value={eDate}
				data-placeholder="날짜선택"
				required
			/>
		</div>
		<div class="retrieve-btn">
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<p on:click={getAllData}>조회하기</p>
		</div>

		<p class="retrieve-title" style="padding-top: 32px;">조회목록</p>
		<div class="list-dtl-wrap scroll-custom">
			<table>
				<tbody>
					<!-- <div>조회 결과가 없습니다.</div> -->
					<tr>
						<th>NO</th>
						<th>항목</th>
						<th>항목</th>
						<th>항목</th>
					</tr>
					<tr on:click={getData}>
						<td>1</td>
						<td>1</td>
						<td>1</td>
					</tr>
					<tr on:click={getData}>
						<td>1</td>
						<td>1</td>
						<td>1</td>
						<td>1</td>
					</tr>
					<tr on:click={getData}>
						<td>1</td>
						<td>1</td>
						<td>1</td>
						<td>1</td>
					</tr>
					<tr on:click={getData}>
						<td>1</td>
						<td>1</td>
						<td>1</td>
						<td>1</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>

<!-- popup -->
<div class="background-r {popupOpen ? 'show-use-r' : ''}">
	<div class="window-r">
		<div class="popup-r">
			<div class="popup-item-dtl">
				<div class="popup-item-dtl-in">
					<p class="popup-main-txt">도어푸쉬브라켓 상4구</p>
					<div class="popup-btn-r">
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<p
							on:click={() => {
								popupOpen = false;
							}}
						>
							닫기
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<style>
</style>
